export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider', 'service-provider')

    .segment('service-provider', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      template: '<service-provider-page></service-provider-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-root.module" */ "./service-provider-root.module");
      }
    });
}
